import toast from 'react-hot-toast';
import { takeEvery, put, call } from 'redux-saga/effects';
import * as invoiceApi from '../../api/invoiceApi';
import * as actions from '../actions';

export function* getInvoices() {
  try {
    yield put(actions.user.setLoading(true));
    const invoices = yield call(invoiceApi.getInvoices);
    yield put(actions.invoices.getInvoicesSuccess(invoices));
  } catch (e) {
    yield put(actions.invoices.getInvoicesFail(e.message));
    toast.error('An error occurred getting the invoices.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* searchInvoices({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const invoices = yield call(invoiceApi.searchInvoices, query);
    yield put(actions.invoices.searchInvoicesSuccess(invoices));
  } catch (e) {
    yield put(actions.invoices.searchInvoicesFailure(e.message));
    toast.error('An error occurred getting the invoices.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* getInvoiceById({ payload: { id } }) {
  try {
    if (!id) {
      return;
    }
    yield put(actions.user.setLoading(true));
    const invoice = yield call(invoiceApi.getInvoiceById, id);
    yield put(actions.invoices.getInvoiceByIdSuccess(invoice[0]));
  } catch (e) {
    yield put(actions.invoices.getInvoiceByIdFail(e.message));
    toast.error('An error occurred getting the invoice.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* addInvoice({ payload: { invoice } }) {
  try {
    yield put(actions.user.setLoading(true));
    const _invoice = yield call(invoiceApi.addInvoice, invoice);
    yield put(actions.invoices.addInvoiceSuccess(_invoice));
    yield put(actions.invoices.getInvoices());
    toast.success('Invoice created.');
  } catch (e) {
    yield put(actions.invoices.addInvoiceFail(e.message));
    toast.error('An error occurred creating the invoice.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* updateInvoice({ payload: { invoice } }) {
  try {
    yield put(actions.user.setLoading(true));
    yield call(invoiceApi.updateInvoice, invoice);
    yield put(actions.invoices.getInvoiceById(invoice.id));
    toast.success('Invoice updated.');
  } catch (e) {
    yield put(actions.invoices.updateInvoiceFail(e.message));
    toast.error('An error occurred updating the invoice.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* invoiceSagas() {
  yield takeEvery(actions.invoices.getInvoiceById, getInvoiceById);
  yield takeEvery(actions.invoices.searchInvoices, searchInvoices);
  yield takeEvery(actions.invoices.getInvoices, getInvoices);
  yield takeEvery(actions.invoices.addInvoice, addInvoice);
  yield takeEvery(actions.invoices.updateInvoice, updateInvoice);
}
